'use strict';

/*globals Waypoint */
var $               = require('jquery');
var purl            = require('purl');

require('waypoints');
require('waypoints-infinite');

var analytics       = require('../utils/analytics.js');
var advert          = require('../adverts/advert.js');
var gridHeights     = require('./grid-heights.js');
var history         = require('./history.js');
var layout          = require('./layout.js');

var infiniteInstance = null;

var loadInfiniteScrolling; // allow for late definition

var setInfiniteScroll = function() {
	var $container = $('.infinite-container');
	var defaultRpp = parseInt($container.attr('data-default-rpp'));
	if (!defaultRpp) {
		defaultRpp = 20;
	}

	infiniteInstance = new Waypoint.Infinite({
		element: $container[0],
		that: this,
		onBeforePageLoad: function() {
			var moreUrl = $container.siblings('a.infinite-more-link').attr('href');
			$container.attr('data-infinite-url', moreUrl);

			$container.find('div.advert[data-id]').removeAttr('id data-id data-ad-placement').addClass('advert-static');

			var url = purl();
			var page = url.param('page');
			var rpp = url.param('rpp');
			var qs = url.param('_qs');

			if (!page || isNaN(page)) {
				page = 1;
			}

			if (!rpp || isNaN(rpp)) {
				rpp = defaultRpp;
			}

			rpp = parseInt(rpp) + defaultRpp;
			var newUrl = url.attr('path') + '?page=' + page + '&rpp=' + rpp;

			if (qs) {
				newUrl = newUrl + '&_qs=' + qs;
			}

			history.setUrl(newUrl);
		},
		onAfterPageLoad: function() {
			var moreUrl = $container.attr('data-infinite-url');
			analytics.trackPageview(moreUrl);
			
			moreUrl = moreUrl.replace(/\d+$/, function(n){ return ++n; });
			$container.attr('data-infinite-url',moreUrl);
			$container.siblings('a.infinite-more-link').attr('href',moreUrl);

			var scroll = parseInt($container.attr('data-infinite-scroll'));
			scroll++;

			if ($container.hasClass('block-grid')) {
				gridHeights.init();
			}

			if ($container.hasClass('equipment-results')) {
				$('.equipment-results').off("unveil");
			}

			$container.siblings('.infinite-more-link').on('click.infinite', function(e) {
				e.preventDefault();
				if (scroll % 5 === 0) {
					var $container = $('.infinite-container');
					if ($container.length > 0) {
						$container.attr('data-infinite-scroll', 0);
						loadInfiniteScrolling();
					}
				}
			});
			if (scroll % 5 === 0) {
				window.setTimeout(function() {
					infiniteInstance.destroy();
				}, 10);
			}

			$container.attr('data-infinite-scroll', scroll);

			advert.loadInfiniteEditorialAds($container);
		}
	});
};

var loadInfiniteScrolling = function () {
	var $container = $('.infinite-container');
	if ($container.length > 0) {

		if (infiniteInstance !== null) {
			infiniteInstance.destroy();
		}

		var disableForXLarge = $container.attr('data-disable-for-xlarge');

		var screenSize = layout.getScreenSize();
		if (disableForXLarge && (screenSize === 'XL' || screenSize === 'XXL')) {
			return;
		}

		setInfiniteScroll();
	}
};

module.exports = {
	init: function () {
		var $container = $('.infinite-container');
		if ($container.length > 0) {
			$container.attr('data-infinite-scroll', 0);
			loadInfiniteScrolling();
		}
	}
};